import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import LoadingWrapper from "../Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";
import scss from "./PurchaseDialog.module.scss";

/**
 * Ask for confirmation when deleting a record.
 *
 * @param {{show: bool, i: int, mutate: *}} openDeleteDialog Additional details for the dialog..
 * @param {string} title The title for the dialog, or null for the default title.
 * @param {string} description The description to show to the user, or null for the default message.
 * @param {function} handleConfirm Callback that will handle confirmation.
 * @param {function} setOpenDeleteDialog Call to change the state of the dialog in the parent.
 *
 * @return {JSX.Element}
 * @constructor
 */

const DeleteDialog = ({
    openDeleteDialog,
    title,
    description,
    handleConfirm,
    setOpenDeleteDialog,
    nameOfButtonDelete,
    deafultIcon = true,
    children,
    setSelectedProducts = () => {},
    selectedProducts = [],
    getAllProducts = () => {},
    products = [],
    loading = false,
    loadingwidth = "",
    showDeleteButton = true,
    nameOfButtonCancel,
    purchase = false,
}) => {
    const { t } = useTranslation();
    const close = () => {
        if (loading) return;
        setOpenDeleteDialog({ ...openDeleteDialog, show: false });
        setSelectedProducts([]);
    };

    return (
        <Dialog open={openDeleteDialog.show ?? false} maxWidth={"md"} fullWidth={purchase} PaperProps={purchase ? { className: scss.paper } : undefined} onClose={purchase ? close : undefined} aria-labelledby={purchase ? "repeat-purchase-title" : undefined} sx={{ minWidth: "312px" }}>
            <DialogTitle id={purchase ? "repeat-purchase-title" : undefined} sx={{ fontFamily: "Montserrat" }}>
                {t(title) ?? "Brisanje"}
                {purchase && <button type="button" className={scss.close} onClick={close} disabled={loading} aria-label="Zatvori"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg></button>}
            </DialogTitle>

            <DialogContent sx={{ minWidth: "312px" }}>
                <DialogContentText sx={{ fontFamily: "Montserrat" }}>{t(description) ?? t("global-message-confirm_delete")}</DialogContentText>
                {children}
            </DialogContent>

            <DialogActions className={purchase ? scss.actions : undefined}>
                {/*toggle add all and delete all buttons*/}
                {products && (
                    <Button
                        sx={{ fontFamily: "Montserrat", fontWeight: "normal" }}
                        color="success"
                        className={`${purchase ? scss.selectAll : ""} ${products?.length === 0 ? "d-none" : ""}`}
                        style={{ marginRight: "auto" }}
                        variant="outlined"
                        disabled={purchase && loading}
                        onClick={() => {
                            if (selectedProducts?.length > 0) {
                                setSelectedProducts([]);
                            } else {
                                getAllProducts(products);
                            }
                        }}
                        data-test-id="btn-cancel"
                    >
                        {selectedProducts?.length > 0 ? t("global-default-text-remove_all_products") : t("global-default-text-mark_all_products")}
                    </Button>
                )}
                <Button
                    className={purchase ? scss.cancel : undefined}
                    disabled={purchase && loading}
                    sx={{ fontFamily: "Montserrat", fontWeight: "normal" }}
                    color="success"
                    variant="outlined"
                    onClick={() => {
                        setOpenDeleteDialog({ ...openDeleteDialog, show: false });
                        setSelectedProducts([]);
                    }}
                    data-test-id="btn-cancel"
                >
                    {nameOfButtonCancel ? t(nameOfButtonCancel) : t("global-default-text-Cancel")}
                </Button>
                {showDeleteButton && (
                    <Button
                        className={purchase ? scss.confirm : undefined}
                        sx={{ fontFamily: "Montserrat", fontWeight: "normal", backgroundColor: "var(--croonus-lightRed)", "&:hover": { backgroundColor: "var(--croonus-darkRed)" } }}
                        variant="contained"
                        disabled={loading || (purchase && !selectedProducts?.length)}
                        startIcon={deafultIcon ? <Icon>delete</Icon> : null}
                        onClick={handleConfirm}
                        data-test-id="btn-confirm"
                    >
                        <LoadingWrapper color={"#FFFFFF"} size={23} className={`p-0 ${loadingwidth}`} isLoading={loading}>
                            {nameOfButtonDelete ? t(nameOfButtonDelete) : t("global-default-text-Delete")}
                        </LoadingWrapper>
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDialog;
